module.exports = __webpack_public_path__ + "img/img_background_curve.cef60cd9.png";